import { render, staticRenderFns } from "./RemInfo.vue?vue&type=template&id=4ce35100&scoped=true&"
import script from "./RemInfo.vue?vue&type=script&lang=js&"
export * from "./RemInfo.vue?vue&type=script&lang=js&"
import style0 from "./RemInfo.vue?vue&type=style&index=0&id=4ce35100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce35100",
  null
  
)

export default component.exports